
import React, { useState, useEffect } from 'react';
import { useLocale } from '../../components/special/LanguageProvider';
import { apiGetCall, isResultOk, apiPostCall } from '../../components/special/apiCall';
import ListTable from '../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextRegno from '../../components/text/TextRegno';
import TextPhonenumber from '../../components/text/TextPhonenumber';
import ReactTooltip  from 'react-tooltip';
import TextDate from 'components/text/TextDate';
import TextNumber from 'components/text/TextNumber';
import TextAmount from 'components/text/TextAmount';
import TextDateTime from '../../components/text/TextDateTime';
import Button from 'jsx/elements/buttons/Button';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const CacheList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/management/status/cache');
    if (isResultOk(data, setListError, true)){        
     // console.log("Data",data);
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  const onClearCache = () => {
    apiPostCall(BASE_URL + '/management/status/cache/clear').then( data => {
      loadList();       
    });
    
  }


  return (    
    <div>            
      <ListHeader title={t("Cache keys")}>
          <div className="text-right">
                <Button text="Clear cache" color="gray" iconright="true" onClick={onClearCache}></Button>
           </div>

      </ListHeader>
      <ReactTooltip/>
      {!listLoading && list && (<div>Total number of keys {list.length}</div>)}
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['']}
          headers = {[
            t("Key")            
          ]}
          columns = {[
            (item) => (<>{ item }</>)
          ]}

      />
  </div>
  );
};




